// extracted by mini-css-extract-plugin
export var arrowLink = "FullSectionCard-module--arrowLink--7ae6c";
export var bannerLeft = "FullSectionCard-module--bannerLeft--235d0";
export var bannerParent = "FullSectionCard-module--bannerParent--78da9";
export var bannerRight = "FullSectionCard-module--bannerRight--20e4a";
export var banner_imgShow = "FullSectionCard-module--banner_imgShow--7b917";
export var contentImg = "FullSectionCard-module--contentImg--46bf2";
export var contentimgParent = "FullSectionCard-module--contentimgParent--aed2f";
export var method_2 = "FullSectionCard-module--method_2--076e0";
export var noBgColor = "FullSectionCard-module--noBgColor--dcac4";
export var noGradient = "FullSectionCard-module--no-gradient--a23ec";
export var scndBgImg = "FullSectionCard-module--scndBgImg--8b282";